import {
    EditableEntity,
    IEditableEntity,
    IPropEventBroker,
    IReadablePropEventBroker,
} from '@zdrbm/zdr-native-tools';
import { ResourceDataType } from '../../services/AssistantDTOs';
import { IResourceSelectorFactory } from 'features/pi/model/resources/IResourceSelectorFactory';

export type SelectorResult<T> = T extends IResourceSelectorFactory<infer U> ? U : never;

export interface IResource<T extends ResourceDataType = any, TData = any> extends IEditableEntity {
    type: IReadablePropEventBroker<T>;
    data: IReadablePropEventBroker<TData>;
    updateFrom(otherResource: IResource<T, TData>): void;
    selectFromFactory<T extends IResourceSelectorFactory<any>>(
        selectorFactory: T,
    ): SelectorResult<T>;
}
export type resourceProps<T, TData> = {
    type: T;
    data: TData;
};
export abstract class Resource<T extends ResourceDataType, TData>
    extends EditableEntity<keyof IResource<T, TData>>
    implements IResource<T, TData>
{
    type: IPropEventBroker<T>;
    data: IPropEventBroker<TData>;

    constructor(resource: resourceProps<T, TData>) {
        super(undefined);

        this.type = this.createPropEventBroker<T>('type', resource.type);
        this.data = this.createPropEventBroker<TData>('data', resource.data);
    }

    abstract selectFromFactory<T extends IResourceSelectorFactory<any>>(
        selectorFactory: T,
    ): SelectorResult<T>;

    updateFrom(otherResource: IResource<T, TData>): void {
        this.type.set(otherResource.type.get());
        this.data.set(otherResource.data.get());
    }
}
